import * as basicLightbox from "basiclightbox";
import { endlessPaginate } from "endless_pagination/endless-pagination-module.js";
import { MpComments } from "../include/comments.js";

function ready(fn) {
	if (document.readyState !== "loading") {
		fn();
	} else {
		document.addEventListener("DOMContentLoaded", fn);
	}
}

ready(() => {
	const comments = new MpComments();
	comments.loadComments();

	endlessPaginate({
		moreSelector: "span.endless_more",
		moreSelectorDataUrl: "data-more",
	});

	document.addEventListener("commentsloaded", () => {
		for (const el of document.querySelectorAll("._ban_user_from_bacheca")) {
			el.classList.remove("disabled");
		}
	});

	const userId = document.querySelector("#_profile_actions").dataset.id;
	for (const el of document.querySelectorAll("._ban_user_from_bacheca")) {
		el.addEventListener("click", (event) => {
			event.preventDefault();
			const button = event.currentTarget;
			const infringementLightbox = basicLightbox.create(
				document.querySelector("#infringement_form_wrapper").innerHTML,
				{
					onShow: (instance) => {
						const infringementContainer = instance.element();
						const form =
							infringementContainer.querySelector(".infringement-form");
						form.querySelector("#id_typology").value = button.dataset.typology;
						form.querySelector("#id_user").value = userId;
						if (button.dataset.typology === "warning") {
							infringementContainer.querySelector(
								"._infringement_type_title",
							).textContent = "Ammonisci";
							form.querySelector("._expiration_label").classList.add("d-none");
							form.querySelector("#id_expiration").classList.add("d-none");
						}
						form
							.querySelector("input._infringement-send")
							.addEventListener("click", (e) => {
								e.preventDefault();
								form.submit();
							});
					},
				},
			);
			infringementLightbox.show();
		});
	}
});
